(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .service('ShipmentCustomService', ShipmentCustomService);

    ShipmentCustomService.$inject = [ '$http', '$resource' ];

    function ShipmentCustomService( $http, $resource ) {
        return {
            returnShipmentsByPurchAndStatus: returnShipmentsByPurchAndStatus,
            returnShipmentByLot: returnShipmentByLot,
            returnPurchShipmentByLot: returnPurchShipmentByLot,
            returnSaleShipmentByLot: returnSaleShipmentByLot,
            getSiListByContract: getSiListByContract,
            returnShipmentsByPurchContractAndSaleContract: returnShipmentsByPurchContractAndSaleContract,
            returnMinifiedShipmentsByPurchaseAndSaleContract: returnMinifiedShipmentsByPurchaseAndSaleContract,
            returnMinifiedShipmentsByPurchaseAndSaleContractNoStatus: returnMinifiedShipmentsByPurchaseAndSaleContractNoStatus,
            returnMinifiedShipmentForLotDetailModalByLotId: returnMinifiedShipmentForLotDetailModalByLotId,
            returnShipmentsByContract: returnShipmentsByContract,
            returnMinifiedShipmentsByContract: returnMinifiedShipmentsByContract,
            returnSelectedShipments: returnSelectedShipments,
            checkIfShipmentAllContractPaymentTypeIsTheSame: checkIfShipmentAllContractPaymentTypesIsTheSame,
            returnBoolContractPaymentType: returnBoolContractPaymentType,
            checkIfShipmentAllContractUnitTypeIsTheSame: checkIfShipmentAllContractUnitTypeIsTheSame,
            returnBoolContractUnitType: returnBoolContractUnitType,
            returnMonthList: returnMonthList,
            returnUsedContracts: returnUsedContracts,
            returnUsedInvoices: returnUsedInvoices,
            returnUsedGrowths: returnUsedGrowths,
            returnUsedCompanies: returnUsedCompanies,
            searchShipmentsForEligibleInvoice: searchShipmentsForEligibleInvoice,
            searchShipments: searchShipments,
            returnShipmentAuditById: returnShipmentAuditById,
            returnInvoiceNumber: returnInvoiceNumber,
            getShipmentFreightDetails: getShipmentFreightDetails,
            updateShipmentFreightFields: updateShipmentFreightFields,
            getMinifiedShipmentForInvoiceDialogByShipmentId: getMinifiedShipmentForInvoiceDialogByShipmentId,
            updateShipmentStatusById: updateShipmentStatusById,
            findAllNotCancelledShipmentsForController: findAllNotCancelledShipmentsForController,
            returnBoolAgentPartOfPurchase: returnBoolAgentPartOfPurchase
        };

        function returnInvoiceNumber(shipmentNumber) {
            var url = 'api/invoices/shipment/' + shipmentNumber + '/number';
            return $http.get(url);
        }

        function searchShipments(query) {
            var url = "api/shipments/search?query=" + query;
            return $http.get(url);
        }

        function searchShipmentsForEligibleInvoice(query, type) {
            var url = "api/shipments/eligible-invoice?query=" + query + "&invoiceType=" + type;
            return $http.get(url);
        }

        function returnShipmentAuditById(id) {
            var url = "jv/audit/shipments/" + id;
            return $http.get(url);
        }

        function returnUsedInvoices(type) {
            var url = "api/invoices/shipment/filter?type=" + type;
            return $http.get(url);
        }

        function returnUsedContracts(type) {
            var url = "api/contracts/shipment/filter?type=" + type;
            return $http.get(url);
        }

        function returnUsedGrowths() {
            var url = "api/growths/shipment/filter";
            return $http.get(url);
        }

        function returnUsedCompanies(type) {
            var url = "api/companies/shipment/filter?type=" + type;
            return $http.get(url);
        }

        function returnShipmentsByPurchAndStatus( purchId, shipPeriod, status ) {
            var url = "api/shipments?purchId=" + purchId + "&status=" + status + "&shipPeriod=" + encodeURIComponent(  shipPeriod );
            return $http.get(url);
        }

        function returnShipmentByLot( lotId ) {
            var url = "api/shipments/lot/" + lotId;
            return $http.get(url);
        }

        function returnShipmentsByContract( conId ) {
            var url = "api/shipments/contract/" + conId;
            return $http.get(url);
        }

        function returnMinifiedShipmentsByContract(conId) {
            var url = "api/shipments/minified/contract/" + conId;
            return $http.get(url);
        }

        function returnShipmentsByPurchContractAndSaleContract( pConId, sConId ) {
            if( sConId === null ) {
                sConId = 0;
            }
            var url = "api/shipments/purchId/" + pConId + "/saleId/" + sConId;
            return $http.get( url );
        }

        function returnMinifiedShipmentsByPurchaseAndSaleContract(pConId, sConId) {
            if(sConId === null) {
                sConId = 0;
            }
            var url = "api/shipments/minified/purchId/" + pConId + "/saleId/" + sConId;
            return $http.get(url);
        }

        function returnMinifiedShipmentsByPurchaseAndSaleContractNoStatus(pConId, sConId) {
            if(sConId === null) {
                sConId = 0;
            }
            var url = "api/shipments/minified/no-status/purchId/" + pConId + "/saleId/" + sConId;
            return $http.get(url);
        }

        function returnMinifiedShipmentForLotDetailModalByLotId(lotId) {
            var url = "api/shipments/minified/lot/" + lotId + "/detail-modal";
            return $http.get(url);
        }

        function returnPurchShipmentByLot( lotId ) {
            var url = "api/shipments/purchase/lot/" + lotId;
            return $http.get(url);
        }

        function returnSaleShipmentByLot( lotId ) {
            var url = "api/shipments/sale/lot/" + lotId;
            return $http.get( url );
        }

        function getSiListByContract( id, type ) {
            var url = "api/contracts/si/" + id + "?type=" + type;
            return $http.get( url );
        }

        function returnSelectedShipments( shipmentMinDTOs ) {
            var url = "url/shipments/selected";
            return $http({
                url: url,
                method: 'POST',
                data: shipmentMinDTOs,
                headers: {'Content-Type': 'application/json'}
            });
        }

        function checkIfShipmentAllContractPaymentTypesIsTheSame( shipment ) {
            var checks = [];
            var checkA = shipment.contract !== null && shipment.contract !== undefined;
            var checkB = shipment.contractB !== null && shipment.contractB !== undefined;
            var checkC = shipment.contractC !== null && shipment.contractC !== undefined;
            var checkD = shipment.contractD !== null && shipment.contractD !== undefined;
            var checkE = shipment.contractE !== null && shipment.contractE !== undefined;
            var checkF = shipment.contractF !== null && shipment.contractF !== undefined;
            // var checkSale = shipment.saleContract !== null && shipment.saleContract !== undefined;
            var paymentType = null;
            if( checkA ) {
                paymentType = shipment.contract.paymentType;
                checks.push( returnBoolContractPaymentType( shipment.contract, paymentType ) );
            }
            if( checkB && null !== paymentType ) {
                checks.push( returnBoolContractPaymentType( shipment.contractB, paymentType ) );
            }
            if( checkC && null !== paymentType ) {
                checks.push( returnBoolContractPaymentType( shipment.contractC, paymentType ) );
            }
            if( checkD && null !== paymentType ) {
                checks.push(returnBoolContractPaymentType(shipment.contractD, paymentType));
            }
            if( checkE && null !== paymentType) {
                checks.push(returnBoolContractPaymentType(shipment.contractE, paymentType));
            }
            if(checkF && null !== paymentType) {
                checks.push(returnBoolContractPaymentType(shipment.contractF, paymentType));
            }
            // if( checkSale && null !== paymentType ) {
            //     checks.push( returnBoolContractPaymentType( shipment.saleContract, paymentType ) );
            // }
            return $.inArray( false, checks ) !== -1;
        }

        function returnBoolContractPaymentType( contract, paymentType ) {
            return contract.paymentType === paymentType;
        }

        function checkIfShipmentAllContractUnitTypeIsTheSame( shipment ) {
            var checks = [];
            var unitType = null;
            var checkA = shipment.contract !== null && shipment.contract !== undefined;
            var checkB = shipment.contractB !== null && shipment.contractB !== undefined;
            var checkC = shipment.contractC !== null && shipment.contractC !== undefined;
            var checkD = shipment.contractD !== null && shipment.contractD !== undefined;
            var checkE = shipment.contractE !== null && shipment.contractE !== undefined;
            var checkF = shipment.contractF !== null && shipment.contractF !== undefined;
            var checkSale = shipment.saleContract !== null && shipment.saleContract !== undefined;
            if( checkA ) {
                unitType = shipment.contract.qtyUnitType;
                checks.push( returnBoolContractUnitType( shipment.contract, unitType ) );
            }
            if( checkB && null !== unitType ) {
                checks.push( returnBoolContractUnitType( shipment.contractB, unitType ) );
            }
            if( checkC && null !== unitType ) {
                checks.push( returnBoolContractUnitType( shipment.contractC, unitType ) );
            }
            if(checkD && null !== unitType) {
                checks.push(returnBoolContractUnitType(shipment.contractD, unitType));
            }
            if(checkE && null !== unitType) {
                checks.push(returnBoolContractUnitType(shipment.contractE, unitType));
            }
            if(checkF && null !== unitType) {
                checks.push(returnBoolContractUnitType(shipment.contractF, unitType));
            }
            if( checkSale && null !== unitType ) {
                checks.push( returnBoolContractUnitType( shipment.saleContract, unitType ) );
            }
            return $.inArray( false, checks ) !== -1;
        }

        function returnBoolContractUnitType( contract, unitType ) {
            return contract.qtyUnitType === unitType;
        }

        function returnMonthList() {
            return $http.get('api/shipments/monthlist');
        }

        function getShipmentFreightDetails(id) {
            var url = "api/shipments/" + id + "/freight";
            return $http.get(url);
        }

        function updateShipmentFreightFields(id, paymentDate, invoiceAmount, invoiceCurrency, invoiceAmountDisplay) {
            var url = "api/shipments/" + id + "/freight?paymentDate=" + paymentDate + "&invoiceAmount=" + invoiceAmount +
                "&invoiceCurrency=" + invoiceCurrency + "&invoiceAmountDisplay=" + invoiceAmountDisplay;
            return $http.post(url);
        }

        function getMinifiedShipmentForInvoiceDialogByShipmentId(id) {
            var url = "api/shipments/minified/invoice-dialog/" + id;
            return $http.get(url);
        }

        function updateShipmentStatusById(id, status) {
            var url = "api/shipments/" + id + "/new-status/" + status;
            return $http.post(url);
        }

        function findAllNotCancelledShipmentsForController() {
            var url = "api/shipments/controller/options";
            return $http.get(url);
        }

        function returnBoolAgentPartOfPurchase(id) {
            var url = "api/shipments/" + id + "/purchase-contract/agent";
            return $http.get(url);
        }

    }
})();
